import { useState,useEffect } from 'react'
import Axios from 'axios'
import { Typography,Card, CardContent, CardMedia, Grid,Stack } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

const NeswList = () => {
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getArticles = async () => {
            await Axios.get(`https://newsdata.io/api/1/news?apikey=${process.env.REACT_APP_KEY}&category=technology&language=en`)
            .then((response) => {
              setLoading(false)
              setArticles(response.data.results)
            })
            
        }
        getArticles()
    }, [])

    const getContent = () => {
      if(loading){
        return (
          <>
            <Stack alignItems="center">
              <CircularProgress />
            </Stack>
          </>
        )
      }
    };
  return (
    <div>
      {getContent()}
      <Grid container rowSpacing={4} columnSpacing={2} padding={4} >
        {
          articles.filter((item, index) => index < 10).map(article => {
              return (
                <>
                  <Grid item xs={12} sm={6} md={4}>
                    <Card>
                      <CardMedia component='img' height='200' image={article.image_url} alt={article.image_url}></CardMedia>
                      <CardContent >
                        <Typography gutterBottom variant="h5">
                          <a href={article.url}>{article.title}</a>
                        </Typography>
                        <Typography gutterBottom variant="p">
                          {article.description}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                </>
              )
          })
        }
      </Grid>
    </div>
  )
}

export default NeswList